import(/* webpackMode: "eager" */ "/codebuild/output/src1545402741/src/ui-directo/apps/backoffice/src/app/(loginLayout)/login/page.tsx");
